import React from 'react';
import Backdrop from './Backdrop';
import Auxiliary from '../../hoc/Auxiliary';

const Modal = (props) => {

    const classList = ['modal'];
    if (props.show) {
        classList.push('modal--show');
    }

    return (
        <Auxiliary>
            <Backdrop enable={props.show} clicked={props.closed} />
            <div className={classList.join(' ')}>
                <div className="modal-header">{props.title}</div>
                <div className="modal-body">
                    {props.children}
                </div>
                <div className="modal-action">
                    <button className="modal-action__close" onClick={props.closed}>Dismiss</button>
                </div>
            </div>
        </Auxiliary>
    )
}

export default React.memo(Modal);